import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toasted from 'vue-toasted'

Vue.config.productionTip = false

// Notification configuration
Vue.use(Toasted, {
  theme: "outline",
  position: "top-center",
  duration: 5000
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
